module.exports = __webpack_public_path__ + "media/images/850/circadian_rhytm_mimosa_pudica-b2c738c1e1413ad98dc02ccc8fcce1cc.jpg";